import { useMutation, useQueryClient } from "@tanstack/react-query";
import apiClient from "../api-client";
import { messagingKeys } from "./messaging";
import {
  SendFeedbackSchema,
  type SendFeedbackInput,
} from "./dtos/feedback.dto";
import { validateSchema } from "./dtos/validation";

/**
 * Send user feedback to the team Slack channel.
 * Uses: POST /feedback
 */
export function useSendFeedback() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (input: SendFeedbackInput): Promise<void> => {
      const dto = validateSchema(SendFeedbackSchema, input);
      const formData = new FormData();
      formData.append("message", dto.message);
      formData.append("page", dto.page);
      dto.attachments?.forEach((file) => formData.append("attachments", file));
      await apiClient.post("/feedback", formData);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: messagingKeys.conversations(),
      });
    },
  });
}
